/* eslint-disable */
import { useState } from "react";
import { X, AlertTriangle } from "lucide-react";
import { operationsApi } from "./api";
import useModalA11y from "../utils/useModalA11y";
import "./StaffDialogs.css";

export default function RetireStaffDialog({ member, onClose, onRetired }) {
  const modalRef = useModalA11y({ isOpen: true, onClose });
  const todayISO = new Date().toISOString().slice(0, 10);
  const [retiredAt, setRetiredAt] = useState(todayISO);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    setError("");
    try {
      await operationsApi.retireStaff(member.id, {
        retired_at: retiredAt || null,
        reason: reason.trim() || null,
      });
      onRetired && onRetired();
    } catch (err) {
      setError(err.message || "Could not retire");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="vsop-overlay" onClick={onClose}>
      <form
        ref={modalRef}
        className="vsop-modal vsop-modal-narrow"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
        role="dialog"
        aria-modal="true"
        aria-labelledby="vsop-ret-title"
      >
        <div className="vsop-modal-head">
          <h2 id="vsop-ret-title">Retire staff member</h2>
          <button
            type="button"
            className="vsop-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="vsop-warn">
          <AlertTriangle size={16} />
          <span>
            <strong>{member.full_name}</strong> will move to Past Staff
            and their contact details will be hidden from members.
          </span>
        </div>

        <div className="vsop-modal-field">
          <label htmlFor="vsop-r-date">Last day of work</label>
          <input
            id="vsop-r-date"
            type="date"
            value={retiredAt}
            onChange={(e) => setRetiredAt(e.target.value)}
            max={todayISO}
            required
          />
        </div>

        <div className="vsop-modal-field">
          <label htmlFor="vsop-r-reason">Reason (optional)</label>
          <textarea
            id="vsop-r-reason"
            rows={3}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Contract ended · resigned · moved to another society…"
            maxLength={500}
          />
        </div>

        {error && <div className="vsop-modal-error">{error}</div>}

        <div className="vsop-modal-actions">
          <button
            type="button"
            className="vsop-btn-secondary"
            onClick={onClose}
            disabled={busy}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="vsop-btn-primary vsop-btn-warn"
            disabled={busy}
          >
            {busy ? "Retiring…" : "Retire staff"}
          </button>
        </div>
      </form>
    </div>
  );
}
